export default __webpack_public_path__ + "static/media/wiggle.77eede03.svg";